import { createContext, useContext, ReactNode, useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';

export interface UserFromToken {
	dni: string;
}

export const getUserFromToken = (token: string): UserFromToken => {
	const decoded = jwtDecode(token);
	return decoded as UserFromToken;
}

type AuthContextType = {
  token: string | null;
  nombreCompleto: string | null,
  role: string | null;
  login: (token: string, nombreCompleto: string, role: string) => void;
  logout: () => void;
};
 
const AuthContext = createContext<AuthContextType>({} as AuthContextType);
 
export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [token, setToken] = useState<string | null>(localStorage.getItem('token'));
  const [nombreCompleto, setNombreCompleto] = useState<string | null>(localStorage.getItem('nombreCompleto'));
  const [role, setRole] = useState<string | null>(localStorage.getItem('role'));
 
  const login = (newToken: string, newNombreCompleto: string, newRole: string) => {
	if (newToken) localStorage.setItem('token', newToken);
	localStorage.setItem('nombreCompleto', newNombreCompleto);
	localStorage.setItem('role', newRole);
	setToken(newToken);
	setNombreCompleto(newNombreCompleto);
	setRole(newRole);
  };
 
  const logout = () => {
	localStorage.clear();
	setToken(null);
	setNombreCompleto(null);
	setRole(null);
  };
 
  return (
	<AuthContext.Provider value={{ token, role, nombreCompleto, login, logout }}>
	  {children}
	</AuthContext.Provider>
  );
};
 
export const useAuth = () => useContext(AuthContext);